/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Appointment } from '../models/appointment';
import { AppointmentPartial } from '../models/appointment-partial';
import { AppointmentWithRelations } from '../models/appointment-with-relations';
import { Count } from '../models/count';
import { Doctor } from '../models/doctor';
import { DoctorPartial } from '../models/doctor-partial';
import { DoctorWithRelations } from '../models/doctor-with-relations';
import { NewProvider } from '../models/new-provider';
import { Provider } from '../models/provider';
import { ProviderPartial } from '../models/provider-partial';
import { ProviderWithRelations } from '../models/provider-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ProviderControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation providerControllerCount
   */
  static readonly ProviderControllerCountPath = '/providers/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<Count> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation providerControllerFindAppointments
   */
  static readonly ProviderControllerFindAppointmentsPath = '/providers/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAppointments()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<AppointmentWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerFindAppointmentsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AppointmentWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAppointments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments(params: {
    id: string;
    filter?: any;
  }): Observable<Array<AppointmentWithRelations>> {

    return this.findAppointments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AppointmentWithRelations>>) => r.body as Array<AppointmentWithRelations>)
    );
  }

  /**
   * Path part for operation providerControllerCreateAppointment
   */
  static readonly ProviderControllerCreateAppointmentPath = '/providers/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment$Response(params: {
    id: string;
    body?: Appointment
  }): Observable<StrictHttpResponse<Appointment>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerCreateAppointmentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Appointment>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment(params: {
    id: string;
    body?: Appointment
  }): Observable<Appointment> {

    return this.createAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Appointment>) => r.body as Appointment)
    );
  }

  /**
   * Path part for operation providerControllerDeleteAppointment
   */
  static readonly ProviderControllerDeleteAppointmentPath = '/providers/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAppointment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerDeleteAppointmentPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteAppointment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation providerControllerPatchAppointment
   */
  static readonly ProviderControllerPatchAppointmentPath = '/providers/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAppointment$Response(params: {
    id: string;
    where?: any;
    body?: AppointmentPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerPatchAppointmentPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAppointment(params: {
    id: string;
    where?: any;
    body?: AppointmentPartial
  }): Observable<Count> {

    return this.patchAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation providerControllerFindDoctors
   */
  static readonly ProviderControllerFindDoctorsPath = '/providers/{id}/doctor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDoctors()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDoctors$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<DoctorWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerFindDoctorsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DoctorWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDoctors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDoctors(params: {
    id: string;
    filter?: any;
  }): Observable<Array<DoctorWithRelations>> {

    return this.findDoctors$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DoctorWithRelations>>) => r.body as Array<DoctorWithRelations>)
    );
  }

  /**
   * Path part for operation providerControllerCreateDoctor
   */
  static readonly ProviderControllerCreateDoctorPath = '/providers/{id}/doctor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDoctor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDoctor$Response(params: {
    id: string;
    body?: Doctor
  }): Observable<StrictHttpResponse<Doctor>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerCreateDoctorPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Doctor>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDoctor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDoctor(params: {
    id: string;
    body?: Doctor
  }): Observable<Doctor> {

    return this.createDoctor$Response(params).pipe(
      map((r: StrictHttpResponse<Doctor>) => r.body as Doctor)
    );
  }

  /**
   * Path part for operation providerControllerDeleteDoctor
   */
  static readonly ProviderControllerDeleteDoctorPath = '/providers/{id}/doctor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDoctor()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDoctor$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerDeleteDoctorPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteDoctor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDoctor(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteDoctor$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation providerControllerPatchDoctor
   */
  static readonly ProviderControllerPatchDoctorPath = '/providers/{id}/doctor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDoctor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDoctor$Response(params: {
    id: string;
    where?: any;
    body?: DoctorPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerPatchDoctorPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchDoctor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDoctor(params: {
    id: string;
    where?: any;
    body?: DoctorPartial
  }): Observable<Count> {

    return this.patchDoctor$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation providerControllerFindById
   */
  static readonly ProviderControllerFindByIdPath = '/providers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ProviderWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ProviderWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ProviderWithRelations>) => r.body as ProviderWithRelations)
    );
  }

  /**
   * Path part for operation providerControllerReplaceById
   */
  static readonly ProviderControllerReplaceByIdPath = '/providers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: string;
    body?: Provider
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: string;
    body?: Provider
  }): Observable<void> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation providerControllerDeleteById
   */
  static readonly ProviderControllerDeleteByIdPath = '/providers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<void> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation providerControllerUpdateById
   */
  static readonly ProviderControllerUpdateByIdPath = '/providers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: ProviderPartial
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: ProviderPartial
  }): Observable<void> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation providerControllerFind
   */
  static readonly ProviderControllerFindPath = '/providers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProviderWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProviderWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ProviderWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProviderWithRelations>>) => r.body as Array<ProviderWithRelations>)
    );
  }

  /**
   * Path part for operation providerControllerCreate
   */
  static readonly ProviderControllerCreatePath = '/providers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewProvider
  }): Observable<StrictHttpResponse<Provider>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Provider>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewProvider
  }): Observable<Provider> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<Provider>) => r.body as Provider)
    );
  }

  /**
   * Path part for operation providerControllerUpdateAll
   */
  static readonly ProviderControllerUpdateAllPath = '/providers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    body?: ProviderPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderControllerService.ProviderControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll(params?: {
    where?: any;
    body?: ProviderPartial
  }): Observable<Count> {

    return this.updateAll$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

}
